"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Header = ({
  header,
  subHeader
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
  m: 2,
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
    container: true,
    direction: "column",
    alignItems: "center",
    justifyContent: "center",
    children: [Boolean(header) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      size: {
        xs: 12
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h6",
        sx: {
          marginBottom: 4
        },
        children: header
      })
    }), Boolean(subHeader) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      size: {
        xs: 12
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body1",
        sx: {
          marginBottom: 8
        },
        children: subHeader
      })
    })]
  })
});
exports.Header = Header;
//# sourceMappingURL=Header.js.map